module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2QXnx"))).then(() => parcelRequire('hEqeo'));